module.exports = __webpack_public_path__ + "static/media/nan_shen_yi_chang.06494a25.mp3";